import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketTransferGamePanelComponent } from './ticket-transfer-game-panel.component';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { TicketTransferWindowStatusBarComponent } from './ticket-transfer-window-status-bar/ticket-transfer-window-status-bar.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { FGBIconsModule } from '@fgb/portal-component-library/src/lib/shared/icons';

@NgModule({
  declarations: [TicketTransferGamePanelComponent, TicketTransferWindowStatusBarComponent],
  imports: [
    CommonModule,
    CountdownModule,
    PipesModule,
    FGBSharedModule,
    FGBIconsModule
  ],
  exports: [TicketTransferGamePanelComponent, TicketTransferWindowStatusBarComponent],
})
export class TicketTransferGamePanelModule {}
